import { createAction } from '@reduxjs/toolkit';

export const startIntro = createAction('START_INTRO');

export const endIntro = createAction('END_INTRO');
